import React from 'react'
import { Link } from 'react-router-dom'
import { useUserProfile } from '../../../Hook/App'
function Index() {
    const { user } = useUserProfile()
    return (
        <div className="info">
            <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                    <div className="img">
                        <img src={user.meta_data && user.meta_data.profile} />
                    </div>
                    <div className="d-grid mx-2">
                        <span>{user.name}</span>
                        <span className="light">{user.mobile}</span>
                    </div>
                </div>
                <Link to={"/EditProfile"}>
                    <button>ویرایش</button>
                </Link>
            </div>
        </div>
    )
}
export default Index